import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'MC log |||| MC logs',
      fields: {
      },
    }
  }
}